import React from 'react';
import "./CharterNav.css"
import { FaRegUser } from "react-icons/fa";
import { IoMdArrowDropdown } from "react-icons/io";
import UserDataFetcher from '../../../../libs/getUserbyUserId';
import "./CharterNav.css"

const CharterNavbar = () => {
    const {adminData} = UserDataFetcher()
    return (
        <div className='charter-navbar'>
            <h3>Welcome back, <span>{adminData?.user?.first_name} {adminData?.user?.last_name} </span></h3>
            <div className="charter-combination">
            <span>
            <FaRegUser />
            </span>
            <IoMdArrowDropdown />
            </div>
        </div>
    );
}

export default  CharterNavbar;
